import { useLingui } from "@lingui/react/macro";
import TextArea from "@/components/TextArea/TextArea";
import { useFormContext } from "react-hook-form";

export type IDescriptionInputFields = {
  description: string;
};

export const DescriptionInput = ({
  showHelperText = true,
}: {
  showHelperText?: boolean;
}) => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<IDescriptionInputFields>();

  return (
    <TextArea
      label={t`Beskrivning`}
      showOptionalLabel
      description={showHelperText ? t`Visas inte för patienten` : undefined}
      errorMessage={errors.description?.message}
      {...register(`description`)}
    />
  );
};
